module.exports = {
  WinName: 'เลือกเทมเพลต',
  TemplateName: 'ชื่อเทมเพลต',
  OK: 'ยืนยัน',
  Cancel: 'ยกเลิก',
  QueryTemplateFailed: 'ค้นหาเทมเพลตล้มเหลว!',
  Tips: 'แจ้งเตือน',
  PlsSelectTemplate: 'กรุณาเลือกเทมเพลต!',
  Copy: 'คัดลอก',
  TemplateTypes: 'ประเภทเทมเพลต',
  EmailTemp: 'แสดงเทมเพลตอีเมล',
  viewV3: 'แสดงเทมเพลต V3',
  inputTemplateName: 'บันทึกชื่อเทมเพลต',
  notFoundTemplate: 'ไม่พบเทมเพลตประเภทที่ตรงกัน กรุณาเพิ่มเทมเพลตก่อน!',
  batchPrintMore: 'ปริมาณข้อมูลการพิมพ์แบบกลุ่มเกิน {0} รายการ (ขีดจำกัดระบบ) ระบบไม่สามารถโหลดได้ กรุณาติดต่อฝ่ายบริการออนไลน์!',
  noSchemaType: 'ยังไม่ได้บำรุงรักษา SchemaType!',
  printMore: 'จำนวนรายการพิมพ์เกิน \'100\' รายการ เวลาโหลดอาจนานกว่าปกติ ต้องการพิมพ์ต่อหรือไม่?',
  notFoundTemplateFromData: 'ไม่พบเทมเพลต【{0}】 กรุณาตรวจสอบเทมเพลต!',
  notEmptyTemplateName: 'ชื่อเทมเพลตไม่สามารถเว้นว่างได้!',
  hasFoundTemplateName: 'ชื่อเทมเพลตมีอยู่แล้ว!',
  attachmentLarge: 'เนื้อหาของไฟล์แนบมีขนาดใหญ่เกินไป!',
  smtpServerError: 'ข้อผิดพลาดเซิร์ฟเวอร์ SMTP!',
  unConnectSmtp: 'ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ SMTP ได้!',
  notFoundFile: 'ระบบไม่พบไฟล์ที่ระบุ!',
  fileSendError: 'เกิดข้อผิดพลาดในการส่งไฟล์!',
  attachmentTemplateError: 'เกิดข้อผิดพลาดในเทมเพลตไฟล์แนบ!',
  sendEmailSuccess: 'ส่งอีเมลสำเร็จแล้ว!'
}
